import type { PushNotificationData } from '../../native/pushNotifications';
import { aiJobsStore, refreshAiJobsAction } from '../../state/aiJobsStore';
import { installPushListeners, reRegisterIfGranted } from '../../state/pushRegistration';
import { openAdvancedResult } from './openAdvancedResult';

// The notification's deep link (Owner contract 2026-09-13 §10 / §13): the payload names the job;
// the result comes from the server. A tap on a job this device does not know yet (a push that
// outran the sync) asks the server first, then opens it.
export function isAdvancedReviewNotification(data: PushNotificationData): data is PushNotificationData & { jobId: string } {
  return data.kind === 'advancedReviewComplete' && typeof data.jobId === 'string' && data.jobId.length > 0;
}

export async function handleNotificationTap(data: PushNotificationData): Promise<boolean> {
  if (!isAdvancedReviewNotification(data)) return false;
  const jobId = data.jobId;
  let job = aiJobsStore.get().jobs.find((j) => j.id === jobId) ?? null;
  if (!job || job.status !== 'completed') {
    await refreshAiJobsAction({ force: true, jobIds: [jobId] });
    job = aiJobsStore.get().jobs.find((j) => j.id === jobId) ?? null;
  }
  if (!job) {
    // The server does not know it either: fall back to the ids the payload carries.
    if (typeof data.inspectionId !== 'string' || typeof data.areaId !== 'string') return false;
    if (typeof data.itemId !== 'string' || data.itemId.length === 0) return false;
    openAdvancedResult({ id: jobId, inspectionId: data.inspectionId, areaId: data.areaId, itemId: data.itemId });
    return true;
  }
  openAdvancedResult(job);
  return true;
}

// Boot wiring (main.tsx): taps deep-link, foreground arrivals sync, a granted device re-registers.
export function installAiJobPushHandling(): () => void {
  const off = installPushListeners({
    onTapped: (data) => {
      void handleNotificationTap(data);
    },
    onReceived: () => {
      void refreshAiJobsAction({ force: true });
    }
  });
  void reRegisterIfGranted();
  return off;
}
